import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltungs-typ-admin-rollen-hinzufuegen';
import * as api from '../../../clients/veranstaltungstypen';

@Injectable()
export class VeranstaltungstypenVeranstaltungsTypAdminRollenHinzufuegenEffects {

    VeranstaltungsTypAdminRollenHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNGS_TYP_ADMIN_ROLLEN_HINZUFUEGEN),
        mergeMap((x: ac.PostVeranstaltungsTypAdminRollenHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungsTypAdminRollenHinzufuegen(x.veranstaltungsTypRolleMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungsTypAdminRollenHinzufuegenErfolgreichAction(result, x.veranstaltungsTypRolleMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungsTypAdminRollenHinzufuegenFehlerAction(error, x.veranstaltungsTypRolleMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungsTypenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungsTypenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungsTypenCommandService);
        }
        return this.service;
    }
}
